export function BRAND_REQUEST(state) {
  state;
  state.brands = {
    ...state.brands,
    isLoading: true
  };
}
export function BRAND_SUCCESS(state, payload) {
  const data = [];
  payload.data.data.brands.rows.map(item => {
    data.push({
      id: item.brandId || "-",
      principalId: item.principalId || "-",
      brandCode: item.brandCode || "-",
      brandName: item.brandName || "-",
      description: item.description || "-",
      brandLogo: item.brandLogo || "-",
      is_active: item.isActive || false
    });
    return item;
  });

  state;
  state.brands = {
    ...state.brands,
    data: data,
    count: payload.data.data.brands.count,
    status: payload.status,
    isLoading: false
  };
}
export function BRAND_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function GET_BRAND_REQUEST(state) {
  state;
  state.brand = {
    ...state.brand,
    isLoading: true
  };
}
export function GET_BRAND_SUCCESS(state, payload) {
  state;
  state.brand = {
    isLoading: false,
    data: payload.data.brand.row,
    status: payload.status
  };
}
export function GET_BRAND_ERROR(state, payload) {
  state;
  state.brand = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function CREATE_BRAND_REQUEST(state) {
  state;
  state.brand = {
    ...state.brand,
    isLoading: true
  };
}
export function CREATE_BRAND_SUCCESS(state, payload) {
  state;
  state.brands = {
    ...state.brands,
    data: state.brands.data.map(item => {
      if (item.id === payload.brandId) {
        return Object.assign({}, item, payload);
      }
      return item;
    }),
    isLoading: false,
    status: 200
  };
}
export function CREATE_BRAND_ERROR(state, payload) {
  state;
  state.brand = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function EDIT_BRAND_REQUEST(state) {
  state;
  state.brand = {
    ...state.brand,
    isLoading: true
  };
}
export function EDIT_BRAND_SUCCESS(state, payload) {
  state;
  state.brands = {
    ...state.brands,
    data: state.brands.data.map(item => {
      if (item.id === payload.brandId) {
        return Object.assign({}, item, payload);
      }
      return item;
    }),
    isLoading: false,
    status: 200
  };
}
export function EDIT_BRAND_ERROR(state, payload) {
  state;
  state.brand = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function DELETE_BRAND_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function DELETE_BRAND_SUCCESS(state, payload) {
  let index = state.brands.findIndex(item => item.id == payload.id);
  state.brands.splice(index, 1);
  state;
  state.brands;
  state.isLoading = false;
}
export function DELETE_BRAND_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}
